import {$window, $body} from '../Constants';
import HtmlElementsStack from '../Elements/HtmlElementsStack';

// import special HtmlElements
import Banner from '../Elements/Banner';
import Header from '../Elements/Header';
import HorizontalSubMenu from '../Elements/HorizontalSubMenu';
import BackToTopButton from '../Elements/BackToTopButton';
import ContentSlider from '../Elements/ContentSlider';
import ImageSlider from '../Elements/ImageSlider';
import Videos from '../Elements/Videos';
import Form from '../Elements/Form';

import HelperUtility from '../Utility/HelperUtility';

/**
 * Controller for this page
 * Handles page flow and special HtmlElements
 */
class PageController {

    constructor() {
        // Object containing special elements that inherit from HtmlElement
        // relevant page events are delegated to these objects through the controller
        this.htmlElementsStack = new HtmlElementsStack(
            Banner,
            Header,
            HorizontalSubMenu,
            BackToTopButton,
            ContentSlider,
            ImageSlider,
            Videos,
			Form
        );

        this.addHeadlinesClasses();
        this.addAccordionJavascript();
    }

    onReady() {
        // pass ready event to HtmlElements
        this.onEvent('onReady');

        this.bindEventListeners();
        this.setBoxesEqualizer();
    }

    onEvent(fn, e = {}) {
        // pass event to HtmlElements
        this.htmlElementsStack.forEachCallFunction(fn, e);
    }

    bindEventListeners() {
        $window.on({
            'load': e => {this.onEvent('onLoad', e)},
            'scroll': e => {this.onEvent('onScroll', e)},
            'resize': e => {this.onEvent('onResize', e)},
        });
    }

    setBoxesEqualizer() {
        let $rows = $('.row.equalized'),
            boxPadding = 30;

        $rows.each(function() {
            let $columns = $(this).find('.columns.equalize'),
                $row = $(this);

            $columns.each(function() {
                let $boxes = $(this).find('> .box');

                if($boxes.length === 1) {
                    $boxes.css('height', '100%');
                }else if($boxes.length > 1) {
                    $row.foundation('getHeights', function(heights) {
                        let height = Math.max(...heights) / $boxes.length - boxPadding * ($boxes.length - 1);
                        $boxes.css('min-height', height);
                    });

                    new Foundation.Equalizer($row).applyHeight();
                }
            });
        });
    }

	addHeadlinesClasses() {
		let headlines = [
			'h1',
			'h2',
			'h3',
			'h4',
			'h5',
			'h6'
		];

		let headlinesSelectors = '';

		for(let i = 0; i < headlines.length; i++) {
			if(i > 0) {
				headlinesSelectors += ', ';
			}

			headlinesSelectors += headlines[i] + ', .' + headlines[i];
		}

		$body.find(headlinesSelectors).each(function() {
			if(!$(this).hasClass('no-styling-classes')) {
				if($(this).prev().length > 0) {
					let $prevElement = $(this).prev();
					let headlinesIndex = headlines.indexOf($prevElement.prop('tagName').toLowerCase());

					if(headlinesIndex > -1) {
						$(this).addClass(headlines[headlinesIndex] + '-prev');
					}else {
						let classIndex = HelperUtility.hasOneOfClasses($prevElement, headlines);

						if(classIndex > -1) {
							$(this).addClass(headlines[classIndex] + '-prev');
						}else {
							$(this).addClass('el-prev');
						}
					}
				}else {
					let $parentPrevElement = $(this).parent().prev();

					if($parentPrevElement.length > 0) {
						$(this).addClass('el-parent-prev');
					}else {
						$(this).addClass('no-el-prev');
					}
				}

				if($(this).next().length > 0) {
					let $nextElement = $(this).next();
					let headlinesIndex = headlines.indexOf($nextElement.prop('tagName').toLowerCase());

					if(headlinesIndex > -1) {
						$(this).addClass(headlines[headlinesIndex] + '-next');
					}else {
						let classIndex = HelperUtility.hasOneOfClasses($nextElement, headlines);

						if(classIndex > -1) {
							$(this).addClass(headlines[classIndex] + '-next');
						}else {
							$(this).addClass('el-next');
						}
					}
				}else {
					let $parentNextElement = $(this).parent().next();

					if($parentNextElement.length > 0) {
						$(this).addClass('el-parent-next');
					}else {
						$(this).addClass('no-el-next');
					}
				}
			}
		});
	}

	addAccordionJavascript() {
		$('[data-accordion]').each(function() {
			if($(this).data('accordion') !== '') {
				let $accordion = $(this);

				if($(this).data('multi-expand') != 'true') {
					$(this).find('.accordion-item > a').on('click', function() {
						let $clickedAccordionItem = $(this).parent('.accordion-item');

						$('[data-accordion="' + $accordion.data('accordion') + '"]').each(function() {
							let $curAccordion = $(this);

							$curAccordion.find('.accordion-item').not($clickedAccordionItem).each(function() {
								$curAccordion.foundation('up', $(this).find('.accordion-content'));
							});
						});
					});
				}
			}
		});
	}
}

export default (new PageController);